var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel"},[(_vm.title!==false)?_c('div',{staticClass:"panel-title"},[_vm._t("title")],2):_vm._e(),_c('div',{staticClass:"panel-content"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }